import React, { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "919845342025";
const DEFAULT_MSG =
  "Hi Tatva Wellness Center, I'd like to know more about your naturopathy treatments and book a consultation.";

const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);
  const [showTip, setShowTip] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll);
    // Auto-show a friendly tip after a short delay on first visit
    const seen = sessionStorage.getItem("tatva_wa_tip");
    if (!seen) {
      const t = setTimeout(() => {
        setShowTip(true);
        sessionStorage.setItem("tatva_wa_tip", "1");
      }, 4000);
      const h = setTimeout(() => setShowTip(false), 12000);
      return () => {
        clearTimeout(t);
        clearTimeout(h);
        window.removeEventListener("scroll", onScroll);
      };
    }
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  return (
    <div
      className={`fixed z-[60] right-5 bottom-5 md:right-7 md:bottom-7 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {showTip && (
        <div className="relative bg-white border border-[#efe7d5] rounded-2xl shadow-[0_16px_40px_rgba(27,94,58,0.18)] px-4 py-3 pr-9 max-w-[260px] animate-[fadeInUp_0.5s_ease-out]">
          <p className="font-serif text-[#1b5e3a] text-[15px] leading-snug">
            Namaste! Have a question?
          </p>
          <p className="text-xs text-[#6b7568] mt-0.5">
            Chat with our team on WhatsApp.
          </p>
          <button
            onClick={() => setShowTip(false)}
            className="absolute top-2 right-2 w-6 h-6 rounded-full text-[#6b7568] hover:text-[#1b5e3a] hover:bg-[#fbf9f4] flex items-center justify-center"
            aria-label="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          <span className="absolute -bottom-2 right-8 w-4 h-4 bg-white border-b border-r border-[#efe7d5] rotate-45" />
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative flex items-center justify-center"
        onMouseEnter={() => setShowTip(true)}
      >
        {/* Pulse rings */}
        <span className="absolute inset-0 rounded-full bg-[#25D366]/50 animate-ping" />
        <span className="absolute inset-0 rounded-full bg-[#25D366]/20 animate-pulse" />
        <span className="relative w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.45)] group-hover:scale-105 group-hover:bg-[#1EBE58] transition-all duration-300">
          <MessageCircle className="w-7 h-7 md:w-8 md:h-8" strokeWidth={2} />
        </span>
      </a>
    </div>
  );
};

export default WhatsAppFloat;
